<template>
  <v-row no-gutters>
    <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="$t('general.sendSms')"/>
    <v-col cols="12" style="padding-top: 50px">
      <v-form v-model="sms.valid"
              class="pb-3"
              ref="smsForm"
              lazy-validation>
        <SmsData :color="mainColor"
                 show-send-button
                 :shortHeight="$vuetify.breakpoint.lgAndDown"
                 :sms="sms"
                 :sending-sms="sms.loading"
                 @sendSms="sendSmsToUser()"/>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import SmsData from '@/pages/App/Communications/Sms/SmsData'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
export default {
  components: { ComponentsFixedBar, SmsData },
  computed: {
    ...mapState({
      selectedUser: state => state.users.selectedUser
    })
  },
  data () {
    return {
      sms: {
        loading: false,
        message: '',
        valid: true
      }
    }
  },
  methods: {
    async sendSmsToUser () {
      try {
        if (!this.$refs.smsForm.validate()) return

        this.sms.loading = true
        const data = {
          country: this.selectedCountryPhone.code,
          countryCode: this.selectedCountryPhone.number,
          message: this.sms.message,
          phone: this.selectedCountryPhone.phone
        }

        await this.$store.dispatch('sendSmsToUser', data)
        notifications.success(this.$t('general.messageSuccessfullySent'))
        this.$refs.smsForm.reset()
        this.sms.loading = false
      } catch (e) {
        notifications.error(e.message)
        this.sms.loading = false
      }
    }
  },
  props: {
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    selectedCountryPhone: {
      type: Object
    }
  }
}
</script>
